import { MilestoneItemName } from './MilestoneStage';
import { BaseBoundaryDates } from './StudyMilestones';

interface Milestone {
  type: 'milestone';
  name: MilestoneName;
  nameTooltip: MilestoneName;
  status: MilestoneStatus;
  values: BaseBoundaryDates;
  delta: string;
  connections: MilestoneItemName[] | null;
  baselineToActual: number | null;
  isKeyMilestone: boolean;
}

type MilestoneName =
  | 'Award date'
  | 'Evidence of agreement'
  | 'Final protocol received'
  | 'First study site activated'
  | 'First subject screened'
  | 'First subject enrolled'
  | '50% sites activated'
  | 'Last site activated'
  | '50% subjects enrolled'
  | 'Last subject enrolled'
  | 'Last subject last visit'
  | 'Database lock'
  | 'Final TLFs to MW'
  | 'Tables, listings, and figures available'
  | 'Final tables, listings and figures to medical writer'
  | 'Final clinical study report delivery';

type MilestoneStatus = `${MilestoneStatusEnum}`;

enum MilestoneStatusEnum {
  OnTrack = 'On Track',
  AtRisk = 'At Risk',
  Upcoming = 'Upcoming',
  Completed = 'Completed',
  CompletedAccelerated = 'Completed | Accelerated',
  CompletedLate = 'Completed | Late',
  CompletedOnTime = 'Completed | On Time',
  PastDue = 'Past Due'
}

interface MilestoneConnections {
  id: number;
  connectionIds: number[];
  connections: MilestoneItemName[];
}

interface MilestoneTask {
  label: MilestoneItemName;
  id: number;
  connections?: MilestoneTaskConnection[];
  tasks?: MilestoneTask[];
}

interface MilestoneTaskConnection {
  target: number;
  type: number;
}

export { MilestoneStatusEnum };
export type {
  Milestone,
  MilestoneConnections,
  MilestoneName,
  MilestoneStatus,
  MilestoneTask,
  MilestoneTaskConnection
};
